import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import { dashboard } from './dashboard.reducer';
import { tmDashboard } from './tmDashboard.reducer.js';
import { product } from './product.reducer';
import { aiChatbot } from './aiChatbot.reducer.js'

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  alert,
  dashboard,
  tmDashboard,
  product,
  aiChatbot
});

export default rootReducer;
